import { useTranslation } from 'react-i18next'
import {
  Box,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  useColorModeValue,
  Flex,
  Icon,
} from '@chakra-ui/react'
import { EditIcon, ArrowForwardIcon, ViewIcon, SunIcon } from '@chakra-ui/icons'

const ProcessStep: React.FC<{
  number: number
  title: string
  description: string
  icon: React.ElementType
  isLast?: boolean
}> = ({ number, title, description, icon, isLast = false }) => {
  const bgColor = useColorModeValue('white', 'gray.800')
  const numberColor = useColorModeValue('purple.500', 'purple.300')
  const arrowColor = useColorModeValue('gray.300', 'gray.600')

  return (
    <Flex direction="column" align="center" position="relative" flex={1}>
      <Box
        bg={bgColor}
        p={6}
        borderRadius="lg"
        boxShadow="md"
        width="100%"
        position="relative"
        zIndex={1}
        _hover={{
          transform: 'translateY(-5px)',
          transition: 'transform 0.3s ease',
        }}
      >
        <VStack spacing={4} align="center">
          <Icon as={icon} w={8} h={8} color={numberColor} />
          <Heading as="h3" size="md" textAlign="center">
            {title}
          </Heading>
          <Text
            textAlign="center"
            color={useColorModeValue('gray.600', 'gray.300')}
          >
            {description}
          </Text>
        </VStack>
      </Box>
      {!isLast && (
        <Icon
          as={ArrowForwardIcon}
          w={8}
          h={8}
          color={arrowColor}
          position="absolute"
          right="-2.5rem"
          top="50%"
          transform="translateY(-50%)"
          display={{ base: 'none', md: 'block' }}
        />
      )}
    </Flex>
  )
}

const HowInterpretationWorksSection: React.FC = () => {
  const { t } = useTranslation()
  const headingColor = useColorModeValue('purple.600', 'purple.300')
  const bgColor = useColorModeValue('white', 'gray.800')

  return (
    <Box>
      <VStack spacing={8}>
        <Heading as="h2" size="lg" color={headingColor} textAlign="center">
          {t('dreamInterpretation.howItWorks.title')}
        </Heading>
        <Text
          textAlign="center"
          fontSize="lg"
          color={useColorModeValue('gray.600', 'gray.300')}
          maxW="2xl"
        >
          {t('dreamInterpretation.howItWorks.description')}
        </Text>

        <SimpleGrid
          columns={{ base: 1, md: 3 }}
          spacing={{ base: 8, md: 12 }}
          width="full"
          pt={4}
        >
          <ProcessStep
            number={1}
            title={t('dreamInterpretation.howItWorks.steps.step1.title')}
            description={t(
              'dreamInterpretation.howItWorks.steps.step1.description',
            )}
            icon={EditIcon}
          />
          <ProcessStep
            number={2}
            title={t('dreamInterpretation.howItWorks.steps.step2.title')}
            description={t(
              'dreamInterpretation.howItWorks.steps.step2.description',
            )}
            icon={ViewIcon}
          />
          <ProcessStep
            number={3}
            title={t('dreamInterpretation.howItWorks.steps.step3.title')}
            description={t(
              'dreamInterpretation.howItWorks.steps.step3.description',
            )}
            icon={SunIcon}
            isLast
          />
        </SimpleGrid>
      </VStack>
    </Box>
  )
}

export default HowInterpretationWorksSection
